// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubscriptionSweep_StaffExtendInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /cli/subscription_sweep/staff_extend
 *
 * Pushes grace_until forward by $days days for a subscription.
 * Full-gated: only staff with the 'Full' or 'Master' Cognito group may call this.
 */
import { registerContract } from './validate'

export interface SubscriptionSweep_StaffExtendInput {
subscription_id: number
days: number
}

registerContract('SubscriptionSweep_StaffExtendInput', {
  subscription_id: { type: 'number',  required: true },
  days:            { type: 'number',  required: true },
})
